import React, { SVGAttributes } from 'react';

export function MedCardOutline(props: SVGAttributes<unknown>): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='none' {...props}>
      <title>Med Card Outline</title>
      <path
        d='M23 14.5H5C1 14.5 1 18.5 1 18.5V39.5C1 43.5 5 43.5 5 43.5H41C45 43.5 45 39.5 45 39.5V29V26'
        stroke='black'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M8 21H18V30H8V21Z' stroke='black' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M8.12793 36.5H16.9999' stroke='black' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M29 36.5H37.476' stroke='black' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M25.582 30H37.476' stroke='black' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <circle cx='37' cy='15' r='10' stroke='black' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M32 15.5L35 18.5L42.5 11' stroke='black' strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
}
